type ArrowDirection = "left" | "right" | "down" | "upRight";

const rotations: Record<ArrowDirection, number> = {
  left: 180,
  right: 0,
  down: 90,
  upRight: -45,
};

export function ArrowIcon({ direction = "right" }: { direction?: ArrowDirection }) {
  return (
    <svg className="link-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={{ display: "block", flexShrink: 0 }}>
      <path d="M3 8h10M8.5 3.5 13 8l-4.5 4.5" transform={`rotate(${rotations[direction]} 8 8)`} />
    </svg>
  );
}
